<div class="wrapper loading-box" *ngIf="loadConfig || !delayPassed">
  <div>
    <img src="{{getAssets()?.logo}}" alt="" width="100px">
  </div>
  <img src="{{getAssets()?.loading}}" alt="" width="80px">
</div>
<router-outlet *ngIf="!loadConfig && delayPassed">
  <div class="app-webphone-container" *ngIf="(isRegistered$ | async) && isLogined() && onCallFunc()">
    <div class="webphone-overlay flex-column align-items-end" *ngIf="showWebphonePopup">
      <etelecom-cs-webphone
        class="webphone-popup"
        (close)="closeWebphone()"
      ></etelecom-cs-webphone>
      <button class="webphone-close-btn" (click)="closeWebphone()">✕</button>
    </div>

    <!-- always-mounted small launcher (optional) -->
    <button class="webphone-launcher" *ngIf="!showWebphonePopup" (click)="toggleWebphone()">
       <i class="material-icons">call</i>
    </button>
  </div>
</router-outlet>

